<template>
    <component
        :is
        v-bind="$attrs"
        ref="inViewTarget"
        :class="viewedClass"
    >
        <slot
            :is-visible
            :viewed
            :viewed-class
        />
    </component>
</template>

<script setup lang="ts">
import { useElementVisibility, watchOnce } from '@vueuse/core';
import type { UseElementVisibilityOptions } from '@vueuse/core';

const props = withDefaults(defineProps<UseElementVisibilityOptions & {
    is?: string,
}>(), {
    is: 'div',
    threshold: 0,
});

const $target = useTemplateRef<HTMLElement | null>('inViewTarget');
const isVisible = useElementVisibility($target, props);

const viewed = shallowRef(false);
watchOnce(isVisible, (newVal) => {
    viewed.value = newVal;
});

const viewedClass = computed(() => {
    return {
        'inview--observing': true,
        'inview--viewed': viewed.value,
        'inview--viewing': isVisible.value,
    };
});

const emit = defineEmits(['enter', 'leave']);
watch(isVisible, (newVal) => {
    if (newVal) {
        emit('enter');
    } else {
        emit('leave');
    }
});
</script>
